/**
 * Sentry client-side configuration for Fuel Estimator.
 *
 * Captures browser errors, unhandled rejections, Mapbox GL JS crashes,
 * Zustand state errors, and React render failures. Also records session
 * replays when errors occur so we can see what the user was doing in the
 * seconds before the crash.
 *
 * Loaded by Next.js itself: `instrumentation-client.ts` runs in the browser
 * before the app hydrates. (It used to be `sentry.client.config.ts`, which
 * only Sentry's webpack plugin injects — under Turbopack it never loaded, so
 * browser errors weren't reaching Sentry.)
 */

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs'

Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

	/**
	 * Capture 100% of errors. Fuel is public-facing and low-volume today —
	 * we want full fidelity. Tune down when sustained traffic is a concern.
	 */
	tracesSampleRate: 1.0,

	/**
	 * Record session replays only when errors occur. Captures the last ~60s
	 * of DOM + user interactions for context without the privacy/cost overhead
	 * of recording every session.
	 */
	replaysOnErrorSampleRate: 1.0,
	replaysSessionSampleRate: 0,

	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

	/**
	 * Tag every event with `app: 'fuel-estimator'` so the dashboard can filter
	 * fuel events from other apps if they ever share a Sentry project.
	 */
	initialScope: {
		tags: { app: 'fuel-estimator' },
	},

	/** Don't send errors in development — we see them in the browser console */
	enabled: process.env.NODE_ENV === 'production',
})

/** Lets Sentry trace client-side navigations (App Router). */
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
